import React, { useState } from 'react';
import { graphql, Link } from "gatsby"
import { uniqby } from "lodash"
import Image from "gatsby-plugin-sanity-image"

import Pancake from "./Pancake";
import Container from "../Container";
import PancakeIntro from "../PancakeIntro";

import Card from "../Card"
import Button from "../Button"
import Avatar from "../Avatar"

import "./VideosList.scss";

const VideosList = props => {
  const { title, text, videos, filteredVideos, showFilters, theme } = props;

  const Filters = ({videos}) => {

    const tags = videos.map(video => video.tags);
    const flatTags = tags.flat();
    const uniqTags = uniqby(flatTags, "name").sort();

    const getVideoLengthByTag = tag => {
      return videos.filter(video => video.tags.find(videoTag => videoTag.name === tag)).length
    }
  
    return (
      <div className="VideosListFilters">
        <span className="VideosListFiltersTitle">Filter by</span>
        <Link to="/videos/" activeClassName="corporate-light" className="Button light with-border">All ({videos.length})</Link>
        {uniqTags.map(tag => {
        return <Link to={`/videos/${tag.slug.current}/`} activeClassName="corporate-light" className="Button light with-border">{tag.name} ({getVideoLengthByTag(tag.name)})</Link>})}
      </div>
    )
  }

  const videosList = filteredVideos.length > 0 ? filteredVideos : videos;

  return (
    <Pancake className="VideosList" theme={theme}>
      <Container>
        {(title || text) && <PancakeIntro title={title} text={text} />}
        {showFilters && <Filters videos={videos} />}
        <div className="VideosListGrid">
          {videosList.map(video => {
            const videoThumbnail = video.youtubeVideo?.videoID ? `https://img.youtube.com/vi/${video.youtubeVideo.videoID}/maxresdefault.jpg` : "";
            const videoURL = video.externalLink ? video.externalLink : `/videos/${video.slug?.current}`

            return (
              <Card className="VideosListCard" clickable key={video._key} data-filter-tag={video.tags?.map(tag => tag.name)}>
                <Card.Image>
                {video.thumbnail ?
                  <Image
                    {...video.thumbnail.image}
                    width={600}
                    height={338}
                    alt=""
                  />
                  :
                  <img src={videoThumbnail} loading="lazy" alt="" />
                }
                </Card.Image>
                <Card.Title>
                  <span>{video.tags?.map(tag => tag.name).join(", ")}</span>
                  <a href={videoURL} target={video.externalLink ? "_blank" : undefined} rel={video.externalLink ? "noopener noreferrer" : undefined}>
                    {video.title}
                  </a>
                </Card.Title>
                <Card.Content>
                  {video.participants?.map(participant => (
                    <Avatar people={participant} />
                  ))}
                </Card.Content>
              </Card>
            )
          })}
        </div>
      </Container>
    </Pancake>
  );
}

export const query = graphql`
  fragment SanityPancakeVideosList on SanityVideosList {
    _key
    _type
    pancakeIntro {
      pancakeTitle
      pancakeText
    }
    videos {
      _key
      title
      externalLink
      youtubeVideo {
        videoID
      }
      thumbnail {
        image {
          ...ImageWithPreview
        }
      }
      tags {
        name
        slug {
          current
        }
      }
      participants {
        name
        slug {
          current
        }
        image {
          ...ImageWithPreview
        }
      }
      slug {
        current
      }
    }
    filteredVideos {
      _key
    }
    showFilters
    theme
  }
  
`

export default VideosList;